import { Component, Input, TemplateRef, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseGridData, GridCol, gridStatusColors, gridTemplateIds } from '../../helpers/grid-helpers';
import { publicHelpers } from 'src/app/helpers/public-helpers';
import { MatDialog } from '@angular/material/dialog';
import { OnChanges } from '@angular/core';
import { deleteIndexItemFromList, getNumberFromText, moveIndexItemDownInList, moveIndexItemUpInList } from '../../helpers/helpers';
import { DropdownOption } from 'globals/store/programs.data';
import { AddItemRowData, SaveBudgetCellData } from '../../store/reselectors/budget.data';
import { minContents } from '../../helpers/table-helpers.data';
import { Dictionary } from '@ngrx/entity';
import { CommonModule } from '@angular/common';
import { UpDownArrowsComponent } from 'src/app/components/misc/up-down-arrows.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { DatePickerComponent } from 'src/app/components/misc/date-picker.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { SmallButtonComponent } from 'src/app/components/buttons/small-button.component';
import { TrafficLightDropdownComponent } from 'src/app/components/misc/traffic-light-dropdown.component';
import { FilterOutHiddenPipe } from 'src/app/services/pipes/filterOutHidden.pipe';
import { DeleteButtonComponent } from 'src/app/components/buttons/delete-button.component';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';

@Component({
    selector: 'budget-grid',
    templateUrl: './budget-grid.html',
    styleUrls: ['./budget-grid.scss'],
    standalone: true,
    imports: [CommonModule, PrettyNumbersPipe, DeleteButtonComponent, FilterOutHiddenPipe, UpDownArrowsComponent, IconComponent, DatePickerComponent, JoiInputComponent, ToggleTabComponent, DropdownComponent, SmallButtonComponent, TrafficLightDropdownComponent],
})
export class BudgetGridComponent<R extends BaseGridData> implements OnInit, OnChanges {
  @Input() readOnly: boolean = true
  @Input() showDelete: boolean = false
  @Input() dropdownItems: DropdownOption[]

  @Input() message: string
  @Input() emptyMessage: string
  @Input() columns: GridCol[]
  @Input() rows: R[]
  @Input() hiddenColumns: Set<string> = new Set()
  @Input() canAddItems = false
  @Output() saveCell: EventEmitter<SaveBudgetCellData<R>> = new EventEmitter()
  @Output() addItem: EventEmitter<AddItemRowData<R>> = new EventEmitter()
  @Output() chooseDropdown: EventEmitter<DropdownOption> = new EventEmitter()
  @Output() saveRows: EventEmitter<R[]> = new EventEmitter()


  gridTemplateColumns: string
  @Input() fullWidth = false

  helpers = publicHelpers
  gridStatusColors = gridStatusColors
  @ViewChild(gridTemplateIds.gridText, { static: true }) gridText: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridDateSelect, { static: true }) gridDateSelect: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridMoney, { static: true }) gridMoney: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridStatus, { static: true }) gridStatus: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridDropdown, { static: true }) gridDropdown: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridNumber, { static: true }) gridNumber: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridItem, { static: true }) gridItem: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridToggle, { static: true }) gridToggle: TemplateRef<any>
  @ViewChild(gridTemplateIds.gridButton, { static: true }) gridButton: TemplateRef<any>

  deleteTitle = 'Delete Line Item'
  deleteText = 'Are you sure you want to delete this line item?'

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.setTemplates()
    // console.log({ columns: this.columns })
  }

  ngOnChanges() {
    this.setTemplates()
  }

  setTemplates() {
    const usedRows = !this.columns ? 0 : this.columns.filter(c => !this.hiddenColumns || !this.hiddenColumns.has(c.id)).length + (this.readOnly ? 0 : 1) + (this.showDelete ? 1 : 0)
    this.gridTemplateColumns = this.fullWidth ? `repeat(${usedRows}, min-content)` : minContents(usedRows)
  }

  async deleteRow(r: number) {
    this.rows = deleteIndexItemFromList(r, this.rows)
    this.saveRows.emit(this.rows)
  }

  moveUp(i: number) {
    this.rows =  moveIndexItemUpInList(i, this.rows)
    this.saveRows.emit(this.rows)
  }

  moveDown(i: number) {
    this.rows = moveIndexItemDownInList(i, this.rows)
    this.saveRows.emit(this.rows)
  }

  updateNumber(row: R, column: GridCol) {
    const amount = getNumberFromText(row[column.id].amount, column.defaultNumber)
    this.saveCell.emit({ saveData: amount, column, row })
  }

  trackByRow(index, row: R) {
    return row.id
  }

  trackByColumn(index, column: GridCol) {
    return column.id
  }

}

